import * as React from "react";
import {connect} from "react-redux";
import LocationalState, {LocationalConfidence, LocationalRoadObject} from "../LocationalState";
import {ConfidenceIcon} from "./ConfidenceIcon";

interface TagProps {
    feature: LocationalRoadObject,
}

interface DispatchProps {
}

interface StateProps {
}


type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
    };
};

const mapDispatchToProps: DispatchProps = ({
});

function getNumberOfLocationals(numberOfLocationals: number): JSX.Element {
    const pluralLocationals =numberOfLocationals > 1;
    const singleLocational =numberOfLocationals === 1;
    return (
        <>
            {pluralLocationals && <p>Dette vegobjektet er stedfestet til {numberOfLocationals} veger.</p>}
            {singleLocational && <p>Dette vegobjektet er stedfestet til 1 veg.</p>}
        </>
    )
}

function getConfidenceText(confidence: LocationalConfidence): string {
    switch (confidence) {
        case LocationalConfidence.missing: return 'Dette vegobjektet er ikke stedfestet enda.';
        case LocationalConfidence.uncertain: return 'Stedfestingen er usikker.';
        case LocationalConfidence.confident: return 'Stedfestingen er sikker.';
    }
}

function getConfidence(confidence: number): JSX.Element {
    let confidenceText = getConfidenceText(confidence);
    return (
        <div className={"flex"}>
            <p>{confidenceText}</p>
            <ConfidenceIcon type={confidence} size={"m"} synchronized={false} />
        </div>
    )
}

class Component extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }


    render() {
        const {feature} = this.props;
        let numberOfLocationals = feature.locational?.locationals.length;
        if (!numberOfLocationals) {
            numberOfLocationals = 0;
        }
        return (
            <div>
                {getNumberOfLocationals(numberOfLocationals)}
                {getConfidence(feature.locationalConfidence)}
            </div>
        );
    }
}

export const LocationalSummery = connect(mapStateToProps, mapDispatchToProps)(Component);
